import { Map, List } from 'immutable';

export const createErrorsReducer = (types) => {
  const initialState = Map({
    loading: false,
    errorsCountData: List(),
    totalErrors: 0,
  });

  const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case types.GET_TEST_ERRORS.REQUEST:
        return state.set('loading', true);
      case types.GET_TEST_ERRORS.SUCCESS:
        return state.withMutations((newState) => {
          let totalErrors = 0;
          const errorsCountData = payload.buckets.map(({ count, name }) => {
            totalErrors += count;
            return {
              count,
              name,
            };
          });

          newState
            .set('loading', false)
            .set('errorsCountData', List(errorsCountData))
            .set('totalErrors', totalErrors);
        });
      case types.GET_TEST_ERRORS.FAILURE:
      case types.CLEAN_UP:
        return initialState;
      default:
        return state;
    }
  };
  return { reducer, initialState };
};
